module.exports = __webpack_public_path__ + "static/media/mycart_product4.b423dea8.png";